import { useState, useEffect } from 'react';
import axiosInstance from '../axiosInstance';

export const useCurrentStageStatus = (requestId, persona) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCurrentStageStatus = async () => {
      if (!requestId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        // Determine the endpoint based on persona
        if (!persona) {
          return;
        }

        const isEndUser = persona === 'enduser';
        const endpoint = isEndUser
          ? `/api/stages/current-status/enduser/${requestId}`
          : `/api/stages/current-status/${requestId}`;

        const response = await axiosInstance.get(endpoint);
        const result = response.data;

        // console.log("useCurrentStageStatus result", result);
        setData(result);
      } catch (err) {
        console.error('Error fetching current stage status:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCurrentStageStatus();
  }, [requestId, persona]);

  return {
    loading,
    error,
    requestProgress: data?.requestProgress || null,
    stage: data?.stage || null,
    status: data?.status || null,
    data,
  };
};
